// extracted by mini-css-extract-plugin
module.exports = {"root":"y0lI0xCPc5fbTALIKu6I"};